import React, { useCallback, useEffect, useState } from "react";
import getMandatoryEnv from "sites-common/utils/getMandatoryEnv";
import { useDispatch } from "react-redux";
import { navigate } from "gatsby-link";
import { fget } from "gatsby-plugin-hfn-profile/components/Login";
import { setUser, setUserToken } from "gatsby-plugin-hfn-profile/state/actions";

const { mySrcmConfig, keycloakConfig } = getMandatoryEnv([
  "mySrcmConfig",
  "keycloakConfig",
]);

const Oneauth = () => {
  const dispatch = useDispatch();

  const [auth, setAuth] = useState(null);

  useEffect(() => {
    import("hfnauth/main");
    if (typeof window !== "undefined") {
      const storedAuth = localStorage.getItem("pstate");
      setAuth(storedAuth ? JSON.parse(storedAuth) : null);
    }
  }, []);

  useEffect(() => {
    if (auth?.user?.id) {
      dispatch(setUser(auth?.user));
      dispatch(
        setUserToken({
          token: auth?.srcmtoken?.token,
          fbName: "",
          user: auth?.user.email || "",
          uid: auth?.user?.user_firebase_uid,
          type: "fb",
        })
      );
      navigate(localStorage.getItem("LandingPage") || "/");
    }
  }, [auth?.srcmtoken?.token, auth?.user, dispatch]);

  const handleAuth = (status) => {
    const oneAuthElement = document.querySelector("hfn-auth");
    if (
      oneAuthElement &&
      typeof oneAuthElement.handleProfileAuthentication === "function"
    ) {
      oneAuthElement.handleProfileAuthentication(status);
    }
  };

  const getUserProfile = useCallback(
    async ({ access_token }) => {
      const { getSRCMProfile } = await import("hfnauth/main");
      const resData = await getSRCMProfile({
        srcmBaseURL: `${mySrcmConfig?.profileServer}/`,
        xClientId: `${mySrcmConfig?.firestoreClient}`,
        queryParams: [
          "id",
          "name",
          "mobile",
          "phone",
          "user_email",
          "age",
          "gender",
          "abhyas_stage",
          "user_roles",
          "user_firebase_uid",
          "srcm_group",
          "city",
          "city_id",
          "postal_code",
          "address",
        ].join(","),
      });
      if (Object.keys(resData.data)?.length > 0) {
        if (resData.data) {
          resData.data.email = resData?.data?.user_email;
        }
        dispatch(setUser(fget(resData.data, resData?.data?.user_firebase_uid)));
        dispatch(
          setUserToken({
            token: access_token,
            fbName: "",
            user: resData.data.email || "",
            uid: resData?.data?.user_firebase_uid,
            type: "fb",
          })
        );
        handleAuth(true);
        navigate(localStorage.getItem("LandingPage") || "");
      } else {
        handleAuth(false);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    import("hfnauth/main")?.then(() => {
      const oneAuthElement = document.querySelector("hfn-auth");
      if (oneAuthElement) {
        oneAuthElement.loginCallback = async (response) => {
          try {
            const user = response?.data;
            if (!user?.access_token) {
              handleAuth(false);
              return false;
            }
            await getUserProfile({
              access_token: user.access_token,
            });
            return true;
          } catch {
            handleAuth(false);
          }
          return true;
        };
      }
    });
  }, [getUserProfile]);

  return (
    <>
      <hfn-auth
        config={JSON.stringify(keycloakConfig)}
        showCancel="true"
        authType=""
      />
    </>
  );
};

export default Oneauth;
